/* =========================================================
   strive-apio-standalone.js
   Bloque de suscripción independiente de Bogos
   ========================================================= */

(function () {
  "use strict";

  const CONFIG = {
    anchorSelector: "#apio-button-container", // ID del contenedor en el Custom Liquid
    formIdSelector: '[name="id"]',            // Busca el input del variant ID
    apioBaseUrl: "https://market.apio.cl/strive/products/"
  };

  function injectApioOption() {
    // 1. Verificar si ya existe para no duplicar
    if (document.querySelector(".strive-apio-tier")) return;

    // 2. Buscar dónde insertarlo (El contenedor del Custom Liquid)
    const anchor = document.querySelector(CONFIG.anchorSelector);
    if (!anchor) return;

    // 3. Inyectar Estilos solo una vez
    if (!document.getElementById("strive-apio-style")) {
      const style = document.createElement("style");
      style.id = "strive-apio-style";
      style.textContent = `
        .strive-apio-tier { width: 100%; max-width: 100%; margin: 20px 0; box-sizing: border-box; border: 1px solid rgba(0,0,0,.15); border-radius: 10px; padding: 14px 16px; background: #fff; cursor: pointer; transition: all .15s ease; text-align: left; }
        .strive-apio-tier:hover { border-color: rgba(0,0,0,.35); box-shadow: 0 6px 18px rgba(0,0,0,.06); transform: translateY(-1px); }
        .strive-apio-tier-row { display: flex; align-items: flex-start; gap: 12px; }
        .strive-apio-pointer { width: 18px; color: rgba(0,0,0,.55); flex: 0 0 auto; margin-top: 2px; }
        .strive-apio-badges { display: flex; gap: 6px; margin-bottom: 6px; flex-wrap: wrap; }
        .strive-apio-badge { font-size: 12px; font-weight: 700; padding: 4px 8px; border-radius: 6px; line-height: 1; }
        .strive-apio-badge-black { background: #000; color: #fff; }
        .strive-apio-badge-gray { background: #eee; color: #000; font-weight: 600; }
        .strive-apio-title { font-weight: 400; font-size: 14px; margin: 0; color: #000; line-height: 1.4; }
        .strive-apio-out { display: inline-flex; align-items: center; gap: 6px; margin-top: 10px; font-size: 12px; font-weight: 700; opacity: .75; color: #000; }
      `;
      document.head.appendChild(style);
    }

    // 4. Crear el elemento
    const wrap = document.createElement("div");
    wrap.className = "strive-apio-tier";
    wrap.innerHTML = `
      <div class="strive-apio-tier-row">
        <span class="strive-apio-pointer">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 2l7.5 18 2-6 6-2L3 2z" fill="currentColor"/></svg>
        </span>
        <div>
          <div class="strive-apio-badges">
            <span class="strive-apio-badge strive-apio-badge-black">10% OFF</span>
            <span class="strive-apio-badge strive-apio-badge-gray">Suscripción mensual</span>
          </div>
          <p class="strive-apio-title">Recíbelo todos los meses a precio preferencial</p>
          <div class="strive-apio-out">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"/></svg>
            <span>Abre en otra pestaña</span>
          </div>
        </div>
      </div>`;

    // 5. Lógica de clic: Busca el ID de variante dinámicamente
    wrap.onclick = () => {
      const input = document.querySelector('form[action^="/cart/add"] [name="id"]') || 
                    document.querySelector('[name="id"]');
      if (input && input.value) {
        window.open(CONFIG.apioBaseUrl + input.value, "_blank");
      } else {
        console.error("[APIO] No se encontró el ID de la variante.");
      }
    };

    anchor.appendChild(wrap);
  }

  // Ejecución y Observador
  const run = () => injectApioOption();
  run();

  const observer = new MutationObserver(run);
  observer.observe(document.body, { childList: true, subtree: true });

})();